<template>
  <div ref="popover" class="relative inline-block">
    <div @click="toggle">
      <slot name="toggler" />
    </div>

    <transition name="fade">
      <div
        v-if="isOpen"
        ref="content"
        class="absolute z-10"
        :style="contentStyle"
      >
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BasePopover',

  data: () => ({
    isOpen: false,
    contentStyle: {}
  }),

  watch: {
    isOpen(value) {
      if (!value) return

      this.$nextTick(this.adjustPosition)
    }
  },

  mounted() {
    document.addEventListener('click', this.close)
  },

  beforeDestroy() {
    document.removeEventListener('click', this.close)
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },

    close(event) {
      if (!this.$refs.popover.contains(event.target)) {
        this.isOpen = false
      }
    },

    adjustPosition() {
      const content = this.$refs.content

      if (!content) return

      const rect = content.getBoundingClientRect()
      const viewportWidth = window.innerWidth
      const viewportHeight = window.innerHeight
      const newStyle = {}

      if (rect.right > viewportWidth) {
        newStyle.right = '0'
        newStyle.left = 'auto'
      }

      if (rect.left < 0) {
        newStyle.left = '0'
        newStyle.right = 'auto'
      }

      if (rect.bottom > viewportHeight) {
        newStyle.bottom = '100%'
        newStyle.top = 'auto'
        newStyle.marginBottom = '0.5rem'
      }

      // Only update contentStyle if there are actual positioning adjustments
      if (Object.keys(newStyle).length > 0) {
        this.contentStyle = newStyle
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
